import { useState } from 'react';
import { KEODataFetchWrapper } from '../wrappers/KEODataFetchWrapper';
import { DataFetchFunction } from '../types/ProgressTypes';
import { EupType } from "../../model";

interface KeoCardMetadata {
    keoId: string;
    cardNumber: string;
    cardStatus?: string;
}

export const useKeoPrint = (onComplete?: () => void) => {
    const [showProgress, setShowProgress] = useState(false);
    const [fetchDataFunction, setFetchDataFunction] = useState<DataFetchFunction | null>(null);
    const [lastGenerationSuccess, setLastGenerationSuccess] = useState(false);
    const [lastGeneratedCardNumber, setLastGeneratedCardNumber] = useState<string | null>(null);
    const [lastCardMetadata, setLastCardMetadata] = useState<KeoCardMetadata | null>(null);

    const fetchKeoPrintData = (
        eupType: EupType,
        keoCardNumbers: string,
        sheetName: string,
    ) => {
        // Resetuj stan sukcesu przed nowym generowaniem
        setLastGenerationSuccess(false);
        setLastGeneratedCardNumber(keoCardNumbers);
        setLastCardMetadata(null);
        
        const dataFetch = KEODataFetchWrapper.wrapKeoCardPrintDataFetch(
            eupType,
            keoCardNumbers,
            sheetName,
        );
        setFetchDataFunction(() => dataFetch);
        setShowProgress(true);
    }
    const resetProgress = () => {
        setShowProgress(false);
        setFetchDataFunction(null);
        // Resetuj również stan sukcesu - ważne przy błędzie generowania
        setLastGenerationSuccess(false);
    };

    const handleProgressComplete = (wasSuccess: boolean, metadata?: KeoCardMetadata) => {
        resetProgress();
        // Oznacz generowanie jako zakończone sukcesem tylko gdy faktycznie był sukces
        if (wasSuccess) {
            setLastGenerationSuccess(true);
            if (metadata) {
                setLastCardMetadata(metadata);
            }
            // Wywołaj callback przekazany z komponentu rodzica tylko przy sukcesie
            if (onComplete) {
                onComplete();
            }
        }
    };

    return {
        showProgress,
        fetchDataFunction,
        fetchKeoPrintData,
        resetProgress,
        handleProgressComplete,
        lastGenerationSuccess,
        lastGeneratedCardNumber,
        lastCardMetadata,
        backTo: '/' // Nie jest już używany, ale zachowany dla kompatybilności
    };
};